import type {BulkOperationResponseBody} from '../types/api/bulkOperations';

/**
 * A cancelled run is terminal at once, but records that were already running still finish and are
 * counted. Until the last one reports, its counts can still grow and `finishedAt` stays null.
 */
export function isBulkOperationSettling(
  operation: Pick<BulkOperationResponseBody, 'state' | 'finishedAt'>
) {
  return operation.state === 'CANCELLED' && operation.finishedAt === null;
}
